/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 保存预约记录接口
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  productId: number,

  success: ({
    data,
    code,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    code: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "GET",
    url: `/good/product/collect/record/${productId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
